import React, { useState } from 'react';
import { applyForCard } from '../../../services/cardService';
import { message } from 'antd'; // Add antd message

const CardApplicationForm = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        identityNumber: '',
        email: '',
        phone: '',
        userGender: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await applyForCard(formData);
            if (res.isSuccess) {
                message.success(res.resultMessage || "Başvuru başarılı!");
                setFormData({ firstName: '', lastName: '', identityNumber: '', email: '', phone: '', userGender: '' });
            } else {
                message.error(res.resultMessage || "Başvuru sırasında hata oluştu.");
            }
        } catch (error) {
            console.error("Başvuru hatası", error);
            message.error("Bir hata oluştu.");
        }
    };

    return (
        <div className="booking-form" style={{ maxWidth: '600px', margin: '20px auto' }}>
            <h4>Kart Başvurusu</h4>
            <div className="form-grid">
                <div className="form-group">
                    <label>Ad</label>
                    <input className="form-input" value={formData.firstName} onChange={e => setFormData({...formData, firstName: e.target.value})} />
                </div>
                <div className="form-group">
                    <label>Soyad</label>
                    <input className="form-input" value={formData.lastName} onChange={e => setFormData({...formData, lastName: e.target.value})} />
                </div>
                <div className="form-group">
                    <label>TC Kimlik No</label>
                    <input className="form-input" maxLength="11" value={formData.identityNumber} onChange={e => setFormData({...formData, identityNumber: e.target.value})} />
                </div>
                <div className="form-group">
                    <label>Telefon</label>
                    <input className="form-input" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} />
                </div>
                <div className="form-group">
                    <label>E-Posta</label>
                    <input className="form-input" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} />
                </div>
                <div className="form-group">
                    <label>Cinsiyet</label>
                    <select className="form-input" value={formData.userGender} onChange={e => setFormData({...formData, userGender: e.target.value})}>
                        <option value="">Seçiniz</option>
                        <option value="Male">Erkek</option>
                        <option value="Female">Kadın</option>
                    </select>
                </div>
            </div>
            <button className="submit-button" onClick={handleSubmit}>Başvuruyu Gönder</button>
        </div>
    );
};

export default CardApplicationForm;
